import SLAConfig from '../../components/admin/sla/SLAConfig';

export default function SLAPage() {
  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>SLA Configuration</h1>
          <p>Set target days for each pipeline stage per fund. Used for SLA tracking dashboards.</p>
        </div>
      </div>
      <SLAConfig />
    </div>
  );
}
